import { LoadedBillingScheduleData } from 'modules/Cube/communication/external/billingSchedule.api.v1/ports/useLoadBillingScheduleEditor'
import { INITIAL_CUBE_STATE } from 'modules/Cube/domain/cube.constants'
import { billingScheduleReducer } from 'modules/Cube/domain/cube.reducer'
import {
  CubeReducerState,
  ScheduleValidationData
} from 'modules/Cube/domain/cube.domain.types'
import { publishScheduleValidation } from 'modules/Cube/domain/postActionStages/validation/validation.schedule.publish'
import { validationResultSetHasErrors } from 'modules/Cube/domain/postActionStages/validation/cube.validation'
import { buildCombinedScheduleData } from 'modules/Cube/view/layouts/quote/QuoteEditorHeader/executeQuote/utils/buildCombinedScheduleData'
import { collectValidationMessages } from 'modules/Cube/view/layouts/quote/QuoteEditorHeader/executeQuote/utils/collectValidationMessages'

/**
 * Resolve the combined schedule through the cube reducer (so the query layer
 * derives phase dates and analysis) and run the publish-schedule validation
 * against it. Returns whether the resulting schedule would be invalid.
 */
export const validateCombinedSchedule = (params: {
  loadedSchedule: LoadedBillingScheduleData
  quoteData: CubeReducerState['data']
  configuration: CubeReducerState['configuration']
  resetBillingPeriod?: boolean
  renewalStartDate?: Date
}): {
  isInvalid: boolean
  validationMessages: string[]
  validationData: ScheduleValidationData
  existingPhaseIds: string[]
} => {
  const { data, configuration, existingPhaseIds } =
    buildCombinedScheduleData(params)

  const resolved = billingScheduleReducer(
    { ...INITIAL_CUBE_STATE, data, configuration },
    { type: 'updateData', payload: {} }
  )

  const validationData: ScheduleValidationData = {
    data: resolved.data,
    queries: resolved.queries,
    configuration: resolved.configuration
  }

  const results = publishScheduleValidation(validationData)

  return {
    isInvalid: validationResultSetHasErrors(results),
    validationMessages: collectValidationMessages(results),
    validationData,
    existingPhaseIds
  }
}
